import { useFullUserProfileContext } from "Bands/contexts";
import { UserBooleanAttribute } from "Bands/types";
import { useUserPreferenceRenderLine } from "Bands/utils";
import { FC } from "react";
import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { Button, List, MainTeaser, Message } from "shared/components";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";

const { userBodyPreferences: bodyCopy } = copy;

interface Props {
  handleShowModal?: (v: boolean) => void;
}

export const UserBodyPreferences: FC<Props> = ({ handleShowModal }) => {
  const { hasBodyPreferences, bodyPreferences } = useFullUserProfileContext();
  const {
    allergies,
    dietaryRequirements,
    otherImportantInformation,
    shirtSize,
    shoeSize,
    smoker,
  } = bodyPreferences || {};

  const { renderLine } = useUserPreferenceRenderLine();

  const renderTeaser = () => (
    <List>
      {renderLine(
        bodyCopy.fields.smoker,
        smoker ? UserBooleanAttribute.yes : UserBooleanAttribute.no
      )}
      {renderLine(bodyCopy.fields.shirtSize.title, shirtSize?.toUpperCase())}
      {renderLine(bodyCopy.fields.shoeSize, shoeSize)}
      {renderLine(bodyCopy.fields.allergies, allergies, true)}
      {renderLine(
        bodyCopy.fields.dietaryRequirements,
        dietaryRequirements,
        true
      )}
      {renderLine(
        bodyCopy.fields.otherImportantInformation,
        otherImportantInformation,
        true
      )}
    </List>
  );

  return (
    <>
      {hasBodyPreferences ? (
        <MainTeaser
          subTitleComponent={renderTeaser()}
          actions={
            handleShowModal && [
              {
                label: copy.actions.edit,
                handleClick: () => handleShowModal(true),
              },
            ]
          }
        />
      ) : (
        <Spacer size="s">
          <Message>No body preferences added yet</Message>
          <Spacer size="s">
            <Button
              onClick={() => handleShowModal && handleShowModal(true)}
              data-testid="add_social_security_form_button"
              theme={ITheme.secondary}
            >
              <Icon as={Plus} />
              <span>Add body preferences</span>
            </Button>
          </Spacer>
        </Spacer>
      )}
    </>
  );
};
